var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1381_635)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    width: 14,
    height: 14,
    rx: 7,
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3125 6.5625H11.6875V3.9375C11.6875 3.82147 11.6414 3.71019 11.5594 3.62814C11.4773 3.54609 11.366 3.5 11.25 3.5C11.134 3.5 11.0227 3.54609 10.9406 3.62814C10.8586 3.71019 10.8125 3.82147 10.8125 3.9375V6.5625H8.1875C8.07147 6.5625 7.96019 6.60859 7.87814 6.69064C7.79609 6.77269 7.75 6.88397 7.75 7C7.75 7.11603 7.79609 7.22731 7.87814 7.30936C7.96019 7.39141 8.07147 7.4375 8.1875 7.4375H10.8125V10.0625C10.8125 10.1785 10.8586 10.2898 10.9406 10.3719C11.0227 10.4539 11.134 10.5 11.25 10.5C11.366 10.5 11.4773 10.4539 11.5594 10.3719C11.6414 10.2898 11.6875 10.1785 11.6875 10.0625V7.4375H14.3125C14.4285 7.4375 14.5398 7.39141 14.6219 7.30936C14.7039 7.22731 14.75 7.11603 14.75 7C14.75 6.88397 14.7039 6.77269 14.6219 6.69064C14.5398 6.60859 14.4285 6.5625 14.3125 6.5625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1381_635",
    x: 0.25,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1381_635"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1381_635",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackAddIcon);
export default __webpack_public_path__ + "static/media/blackAddIcon.2c1c48d6284cf87f9f00c46fcdc8bbf6.svg";
export { ForwardRef as ReactComponent };